<template>
  <div class="content-container">
    <search-comp :search-show="true" @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('searchBox.date') }}</div>
                <div>
                  <CalendarSelect
                    v-model="searchParams.dateSearch"
                    style="display: block"
                    mode="date"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('searchBox.type') }}</div>
                <el-select v-model="searchParams.type" placeholder="">
                  <el-option label="Chọn" :value="null"> </el-option>
                  <el-option label="OOO" :value="1"> </el-option>
                  <el-option label="OOS" :value="2"> </el-option>
                </el-select>
                <!-- <div>
                  <select v-model="searchParams.type">
                    <option :value="null">Chọn</option>
                    <option value="1">OOO</option>
                    <option value="2">OOS</option>
                  </select>
                </div> -->
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('searchBox.room') }}</div>
                <div>
                  <!-- <input v-model="searchParams.roomNum" type="text" /> -->
                  <el-select
                    v-model="searchParams.roomId"
                    placeholder=""
                    filterable
                  >
                    <el-option
                      v-for="option in roomOptions"
                      :key="option.room_id"
                      :label="option.room_num"
                      :value="option.room_id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="false"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @rowClicked="rowSelected = true"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="!rowSelected"
        class="btn primary small outline"
        @click="onDeleteRow"
      >
        {{ this.$t('button.delete') }}
      </button>
      <button
        :disabled="!rowSelected"
        class="btn primary small"
        @click="onEditRow"
      >
        {{ this.$t('button.modify') }}
      </button>
      <button class="btn primary small" @click="dialogFormVisible = true">
        {{ this.$t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit ? $t('dialog.titleOooRoomEdit') : $t('dialog.titleOooRoomAdd')
      "
      :visible.sync="dialogFormVisible"
      :class="isEdit ? 'over-inherit' : ''"
      :close-on-click-modal="false"
      width="700px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <!-- <div class="das-form-group-title">Thông tin đoàn</div> -->
            <!-- <search-comp
              @onSearch="attachData"
              @onReset="onReset"
              v-if="!isEdit"
            > -->
            <div v-if="!isEdit" class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.room') }}</div>
                  <div class="child-w-80">
                    <input
                      v-model="dialogSearchParams.roomNum"
                      type="text"
                      placeholder="Nhập thông tin phòng"
                    />
                  </div>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">
                    {{ $t('dialog.roomLevel') }}
                  </div>
                  <el-select
                    v-model="dialogSearchParams.roomLevel"
                    placeholder=""
                  >
                    <el-option label="Chọn" :value="null"></el-option>
                    <el-option
                      v-for="item in roomLevelOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <hr v-if="!isEdit" />

            <!-- </search-comp> -->
            <div v-if="!isEdit" class="grid-scroll mt-10" style="height: 300px">
              <GridVx
                ref="agGrid1"
                :columns="dialogRoomCols"
                :row-multi-select-with-click="true"
                :auto-size-cell="true"
                :auto-select-first-row="false"
                dom-layout="scroll"
                :rows="dialogRoomRows"
                class="agGrid"
              />
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" :name="$t('dialog.type')">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.type') }}</div>
                    <el-select v-model="submitForm.type" placeholder="">
                      <el-option label="Phòng ngừng sử dụng" :value="1">
                      </el-option>
                      <el-option label="Phòng không phục vụ" :value="2">
                      </el-option>
                    </el-select>
                    <!-- <div class="child-w-80">
                      <select v-model="submitForm.type">
                        <option value="1">Phòng ngừng sử dụng</option>
                        <option value="2">Phòng không phục vụ</option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required"
                  :name="$t('dialog.returnStatus')"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.returnStatus') }}
                    </div>
                    <el-select v-model="submitForm.status" placeholder="">
                      <el-option label="Bẩn" :value="1"> </el-option>
                      <el-option label="Sạch" :value="2"> </el-option>
                      <el-option label="Đã kiểm tra" :value="3"> </el-option>
                    </el-select>
                    <!-- <div class="child-w-80">
                      <select v-model="submitForm.status">
                        <option value="1">Sạch</option>
                        <option value="2">Bẩn</option>
                        <option value="3">Đã kiểm tra</option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('dialog.fromDate') }}
                  </div>
                  <div class="child-w-80">
                    <SingleCalendar
                      v-model="submitForm.date_from"
                      class="use-icon"
                      :date-data="submitForm.date_from"
                    />
                  </div>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('dialog.toDate') }}
                  </div>
                  <div class="child-w-80">
                    <SingleCalendar
                      v-model="submitForm.date_to"
                      class="use-icon"
                      :date-data="submitForm.date_to"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" :name="$t('dialog.type')">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.reason') }}</div>
                    <el-select v-model="submitForm.reason" placeholder="">
                      <el-option
                        v-for="option in reasonOptions"
                        :key="option.id"
                        :value="option.id"
                        :label="option.desc"
                      >
                      </el-option
                    ></el-select>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="!isEdit"
            class="btn primary small"
            @click="submitNewForm"
          >
            {{ $t('button.add') }}
          </button>
          <button v-else class="btn primary small" @click="submitEditedForm">
            {{ $t('button.update') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { getCodeBase } from '@/api/common/code_base'
import { getCodeListApi } from '@/api/common/code'
// import { debounce } from '@/utils/debounce'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import { getAllRoomLevelApi } from '@/api/Room/roomLevel'
import { getAvaiableRoomList } from '@/api/houseKeeper/ooo-room'
import {
  getListOooRoomApi,
  // eslint-disable-next-line no-unused-vars
  addOooRoomApi,
  // eslint-disable-next-line no-unused-vars
  updateOooRoomApi,
  // eslint-disable-next-line no-unused-vars
  deleteOooRoomApi
} from '@/api/houseKeeper/ooo-room'

export default {
  components: {
    SingleCalendar
  },
  data() {
    return {
      roomOptions: [],
      rowSelected: false,
      submitForm: {
        room_id: null,
        type: 1,
        status: 1,
        date_from: null,
        date_to: null,
        reason: null
      },
      loading: false,
      roomLevelOptions: [],
      searchParams: {
        type: null,
        dateSearch: this.$moment(new Date()).format('YYYY-MM-DD'),
        roomNum: null
      },
      dialogSearchParams: {
        roomLevel: null,
        roomNum: null
      },
      isEdit: false,
      time1: new Date(),
      title: null,
      dialogFormVisible: false,
      columns: [
        {
          headerName: this.$t('grid.column.type'),
          field: 'type',
          valueGetter: params => {
            let data
            // eslint-disable-next-line eqeqeq
            if (params.data.type == 1) {
              data = this.$t('grid.column.oooRoom')
            } else {
              data = this.$t('grid.column.oosRoom')
            }
            return data
          },
          tooltipValueGetter: params => {
            let data
            // eslint-disable-next-line eqeqeq
            if (params.data.type == 1) {
              data = this.$t('grid.column.oooRoom')
            } else {
              data = this.$t('grid.column.oosRoom')
            }
            return data
          }
        },
        {
          headerName: this.$t('grid.column.room'),
          field: 'room_name',
          tooltipField: 'room_name',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.fromDate'),
          field: 'date_from',
          maxWidth: 200,
          valueGetter: params => {
            return this.$displayDate(params?.data?.date_from) || null
          },
          tooltipValueGetter: params => {
            return this.$displayDate(params?.data?.date_from) || null
          }
        },
        {
          headerName: this.$t('grid.column.toDate'),
          field: 'date_to',
          maxWidth: 200,
          valueGetter: params => {
            return this.$displayDate(params?.data?.date_to) || null
          },
          tooltipValueGetter: params => {
            return this.$displayDate(params?.data?.date_to) || null
          }
        },
        {
          headerName: this.$t('grid.column.returnStatus'),
          field: 'status',
          valueGetter: params => {
            let data
            // eslint-disable-next-line eqeqeq
            if (params.data.status == 1) {
              data = this.$t('grid.column.dirtyRoom')
              // eslint-disable-next-line eqeqeq
            } else if (params.data.status == 2) {
              data = this.$t('grid.column.cleanRoom')
            } else {
              data = this.$t('grid.column.checkedRoom')
            }
            return data
          },
          tooltipValueGetter: params => {
            let data
            // eslint-disable-next-line eqeqeq
            if (params.data.status == 1) {
              data = this.$t('grid.column.dirtyRoom')
              // eslint-disable-next-line eqeqeq
            } else if (params.data.status == 2) {
              data = this.$t('grid.column.cleanRoom')
            } else {
              data = this.$t('grid.column.checkedRoom')
            }
            return data
          },
          minWidth: 200,
          flex: 1
        },
        {
          headerName: this.$t('grid.column.reason'),
          field: 'reason_string',
          tooltipField: 'reason_string'
        },
        {
          headerName: this.$t('grid.column.createdPerson'),
          field: 'create_user',
          tooltipField: 'create_user'
        },
        {
          headerName: this.$t('grid.column.createdTime'),
          field: 'create_date',
          valueGetter: params => {
            return this.$displayDate(params?.data?.create_date) || null
          }
        }
      ],
      dialogRoomCols: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.room'),
          field: 'room_num',
          tooltipField: 'room_num',
          width: 100
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level',
          tooltipField: 'room_level',
          width: 100
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ],
      rows: [],
      dialogRoomRows: []
    }
  },
  watch: {
    async dialogFormVisible(value) {
      if (value) {
        const { data } = await getAvaiableRoomList()
        this.dialogRoomRows = data
      } else {
        this.resetInfo()
      }
    },
    async 'dialogSearchParams.roomLevel'(value) {
      if (value) {
        const { data } = await getAvaiableRoomList(this.dialogSearchParams)
        this.dialogRoomRows = data
      }
    },
    async 'dialogSearchParams.roomNum'(value) {
      // debounce(async () => {
      if (value) {
        const { data } = await getAvaiableRoomList(this.dialogSearchParams)
        this.dialogRoomRows = data
        // console.log(123)
      }
      // }, 300)
    }
  },
  async mounted() {
    const data = await getAllRoomLevelApi()
    this.roomLevelOptions = data.data
    const data1 = await getCodeListApi({
      pCode: 'RSS'
    })
    const data2 = await getAvaiableRoomList()
    this.roomOptions = data2.data || []
    this.reasonOptions = data1.data || []
    this.attachData()
  },
  methods: {
    onReset() {
      this.searchParams = {
        type: null,
        dateSearch: this.$moment(new Date()).format('YYYY-MM-DD'),
        roomNum: null
      }
      this.attachData()
    },
    async submitNewForm() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      const gridApi1 = this.$refs.agGrid1.gridApi
      const rows = gridApi1.getSelectedRows()
      const params = []
      rows.forEach(item => {
        params.push(item.room_id)
      })
      await addOooRoomApi(
        {
          roomIdList: params
        },
        this.submitForm
      )
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async submitEditedForm() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await updateOooRoomApi(this.submitForm)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    resetInfo() {
      this.isEdit = false
      this.$nullValueInObj(this.submitForm)
      this.$nullValueInObj(this.dialogSearchParams)
      this.dialogRoomRows = []
    },
    onEditRow() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.submitForm, row)
    },
    async onAddRow() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await addOooRoomApi(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateRow() {
      await updateOooRoomApi(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onDeleteRow() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.$vxConfirm(this.$t('alert.deleteConfirm'), async () => {
        await deleteOooRoomApi({
          id_list: [row.id]
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async attachData() {
      this.loading = true
      const data = await getListOooRoomApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.rowSelected = false
    }
  }
}
</script>

<style lang="scss"></style>
